export default "__VITE_ASSET__BQnWxb$T__";